import { render, staticRenderFns } from "./purchasesReturnsTakeOut.vue?vue&type=template&id=60aecfb4&"
import script from "./purchasesReturnsTakeOut.vue?vue&type=script&lang=js&"
export * from "./purchasesReturnsTakeOut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "purchasesReturnsTakeOut.vue"
export default component.exports